import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from "./pages/login/Login";
import TopNav from "./components/TopNav";
import Dashboard from "./pages/dashboard/Dashboard";
import ForgotPasswordPage from "./pages/login/ForgotPasswordPage";
import ResetPasswordPage from './pages/login/ResetPasswordPage';
import "bootstrap/dist/css/bootstrap.min.css";

//css
import "./App.css";

//ico
import reload from "./static/image/reload.svg";

//redux
import { useSelector } from "react-redux";

//constants
import {
  API_CALL_STATUS_LOADING
} from "./utils/constant";

function App() {
  //api status
  // const digitalPriceStatus = useSelector((state) => state.digitalPrice.status);


  // const isShowLoadingScreen = () => {
  //   if (digitalPriceStatus === API_CALL_STATUS_LOADING) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  return (
    <Router>
      <TopNav />

      {/* {isShowLoadingScreen() && (
        <div className="app-loading">
          <img src={reload} alt="loading" className="ao-reloading" />
        </div>
      )} */}

      <div style={{ height: 'calc(100vh - 50px)', overflow: 'hidden' }}> {/* Adjust [height of TopNav] to match your actual nav height */}
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/login/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;